// eslint-disable-next-line import/no-cycle
import api from '@/services/api';

export default {
  initializeStore({ commit, state }) {
    if (!state?.usuario?.id) {
      commit('SET_USUARIO', {});
      commit('SET_EMPRESA', {});
      commit('SET_EMPRESAS', []);
      commit('SET_EMPRESAS_SELECIONADAS', []);
      commit('SET_ESPECIALISTA_COMERCIAL', {});
      commit('SET_ESPECIALISTA_OPERACIONAL', {});
      commit('SET_TIPOS_USUARIO', {});
    }
  },
  updateUser(context, payload) {
    if (payload) {
      context.commit('UPDATE_USER', payload.user);
      localStorage.setItem('token:@CTRL', `Bearer ${payload.token}`);
    } else {
      context.commit('UPDATE_USER', null);
      localStorage.removeItem('token:@CTRL');
    }
  },
  async login({ state, commit, dispatch }, { email, senha }) {
    const response = await api.post('/autenticacao/login', {
      email,
      senha,
    });

    // mantém o perfil anterior de empresas selecionadas, se o usuário estiver relogando
    let empresasSelecionadas;
    if (state?.usuario?.id === response.data.user.id) {
      empresasSelecionadas = [...state.empresasSelecionadas];
    }

    dispatch('updateUser', response.data);

    if (empresasSelecionadas) {
      commit('SET_EMPRESAS_SELECIONADAS', empresasSelecionadas);
    }

    await dispatch('fetchTiposUsuario');
    await dispatch('getAllEmailsWithUserDomain');
    await dispatch('fetchTeamTrinity');
  },
  logoutUser({ dispatch }) {
    dispatch('updateUser', null);
    dispatch('initializeStore', null, { root: true });
  },
  async fetchTiposUsuario({ commit }) {
    const tiposUsuario = await api.get('/usuario/tipos')
      .then((response) => response.data);
    commit('SET_TIPOS_USUARIO', tiposUsuario);
  },
  /**
   * Caso não seja selecionada nenhuma empresa ou algum erro ocorra,
   * todas as empresas disponíveis serão selecionadas no lugar
   */
  selecionarEmpresas({ commit, getters }, payload) {
    // eslint-disable-next-line max-len
    const empresas = Array.isArray(payload) && payload.length > 0 ? payload : getters.getEmpresasUsuario;
    commit('SET_EMPRESAS_SELECIONADAS', empresas);
  },
  async fetchResponsaveis({ commit, dispatch }) {
    try {
      const resOperacional = await api.get('/credenciais/especialista/OPERACIONAL');
      commit('SET_ESPECIALISTA_OPERACIONAL', resOperacional.data);
      const resComercial = await api.get('/credenciais/especialista/COMERCIAL');
      commit('SET_ESPECIALISTA_COMERCIAL', resComercial.data);
    } catch (err) {
      dispatch('toggleLoading', false, { root: true });
      dispatch(
        'setGlobalError',
        'Não foi possível recuperar o especilista do usuário logado.',
        { root: true },
      );
    }

    return null;
  },
  updateUsuarioState({ commit }, payload) {
    commit('UPDATE_USUARIO_STATE', payload);
  },
  getAllEmailsWithUserDomain({ commit }) {
    return api.get('/usuario/emails/domain')
      .then((response) => response.data)
      .then((data) => {
        commit('SET_EMAILS_DOMAIN', data);
      });
  },
  fetchTeamTrinity({ commit }) {
    return api.get('/usuario/dream/team')
      .then((response) => response.data)
      .then((data) => {
        commit('SET_TEAM_TRINITY', data);
      });
  },
  updateLastNotification({ commit }, payload) {
    commit('SET_LAST_FETCH_NOTIFICATIONS', payload);
  },
};
